"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCurrency = normalizeCurrency;
// Free-text currency values occasionally slip in (e.g. "US$" for "USD"); fold
// known aliases together so equality checks and per-currency grouping treat
// them as one currency. Historic DB rows were normalized when the enum landed,
// but values still arrive from documents, imports, and older payloads.
const CURRENCY_ALIASES = { US$: 'USD' };
function normalizeCurrency(currency) {
    if (currency === null)
        return null;
    const trimmed = currency.trim().toUpperCase();
    if (trimmed === '')
        return null;
    return CURRENCY_ALIASES[trimmed] ?? trimmed;
}
//# sourceMappingURL=currency.js.map